import React, { useEffect } from 'react';
import { Alert, Box } from '@mui/material';

/**
 * ErrorAlert - A presentational component for displaying error messages
 * 
 * @param {Object} props
 * @param {string} props.message - The error message to display
 * @param {Function} props.onClose - Callback when alert is closed
 */
const ErrorAlert = ({ message, onClose }) => {
  useEffect(() => {
    if (message && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!message) {
    return null;
  }

  return (
    <Box sx={{ mb: 2, width: '100%' }}>
      <Alert 
        severity="error" 
        onClose={onClose}
        aria-live="assertive"
      >
        {message}
      </Alert>
    </Box>
  );
};

export default ErrorAlert;
